/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/Leads/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { LeadV1ApproveLeadRequest } from '../apis/LeadApi';
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface LeadAgreement
 */
export interface LeadAgreement {
  /**
   *
   * @type {number}
   * @memberof LeadAgreement
   */
  readonly leadId: number;

  /**
   *
   * @type {string}
   * @memberof LeadAgreement
   */
  readonly status: string;

  /**
   *
   * @type {string}
   * @memberof LeadAgreement
   */
  readonly comment: string;
}

export function LeadAgreementFromJSON(json: any): LeadAgreement {
  return LeadAgreementFromJSONTyped(json);
}

export function LeadAgreementFromJSONTyped(json: any): LeadAgreement {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    leadId: !exists(json, 'leadId') ? undefined : json['leadId'],
    status: !exists(json, 'status') ? undefined : json['status'],
    comment: !exists(json, 'comment') ? undefined : json['comment'],
  };
}

export function LeadAgreementToJSON(value?: LeadV1ApproveLeadRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    leadId: value.leadId,
    status: value.status,
    comment: value.comment,
  };
}
